import { __rest } from './_virtual/_tslib.js';
import React from 'react';
import { Box, isValidStyleProperty } from '@vp/swan';
import { SignInContextProvider } from './SignInContext.js';
import { IdMeVerificationButton } from './Verification.js';
export { isCustomerInMilitaryGroup } from './CustomerGroupService.js';

const ShouldShowIdMeVerification = (locale) => {
    return IsValidLocale(locale) && ['en-us', 'es-us'].includes(locale.toLowerCase());
};
const IsValidLocale = (locale) => {
    if (!locale || locale.length !== 5) {
        return false;
    }
    return locale.split('-').length === 2;
};
const IdMeVerification = (_a) => {
    var { onSuccessfulVerification = () => { }, locale, customerId, trackVerificationClick = () => { }, localizedHelpCopy } = _a, props = __rest(_a, ["onSuccessfulVerification", "locale", "customerId", "trackVerificationClick", "localizedHelpCopy"]);
    const swanStyleProps = () => {
        let styleProps = {};
        Object.keys(props).forEach((propKey) => {
            if (isValidStyleProperty(propKey)) {
                styleProps = Object.assign({ [propKey]: props[propKey] }, styleProps);
            }
        });
        return styleProps;
    };
    return (React.createElement(Box, Object.assign({}, swanStyleProps()), ShouldShowIdMeVerification(locale) &&
        React.createElement(SignInContextProvider, { onSuccessfulVerification: () => {
                onSuccessfulVerification();
            }, locale: locale, customerId: customerId, trackVerificationClick: trackVerificationClick, localizedHelpCopy: localizedHelpCopy },
            React.createElement(IdMeVerificationButton, null))));
};

export { IdMeVerification };
//# sourceMappingURL=index.js.map
